






      
import Vue from 'vue'  
import Component from 'vue-class-component'  

@Component({
  name: 'NumberFieldFactor', 
  props:{                          
    positiveOnly:{
      type:Boolean,
      default:false
    },                  
    factor:{
      type:Number,
      default:1
    },
    round:{
      type:Boolean,
      default:false
    },
    value:{
      type:Number,
      default:0
    }
  }
})
export default class NumberFieldFactor extends Vue {  
  
  private factor!:number
  private value!:number  
  private round!:number          
  private positiveOnly!:boolean
  
  inputValue(newV:any) {                              
    this.$nextTick(() => {
      //@ts-ignore
      if(this.$refs.inputfield && !this.$refs.inputfield.badInput){
        let newVal = parseFloat(newV)*this.factor
        if(this.positiveOnly && newVal < 0) {            
          newVal = -newVal    
          //Hack pour si le symbole '-'  est ajouté au début de la zone de text
          //@ts-ignore        
          this.$refs.inputfield.value = 0                                            
          //@ts-ignore        
          this.$nextTick(() => {this.$refs.inputfield.value = newVal})
        } 
        this.$emit('input',this.round?Math.round(newVal):newVal)
      }
    })      
  }
}
